/**
 * M6 WP 6.2 ayar ekranlarının menü ve kabuk metinleri. Kabuk (menü, kullanıcı menüsü) bu modülü kullanır; küçük tutulur —
 * ekranların kendi metinleri sayfalarıyla birlikte tembel yüklenir.
 */
export const settingsNavText = {
  account: 'Hesap ve güvenlik',
  company: 'Şirketim',
  ipAllowlist: 'IP izin listesi',
  appearance: 'Görünüm ve davranış',
  integrations: 'Entegrasyonlar',
  /** v3.1 S7: sağlayıcı bağlantıları */
  connections: 'Bağlantılar',
  /** EK1: ajan profilleri, bağlı uygulama kurulumları ve demo sınaması */
  agents: 'Ajanlar',
} as const;
